import { useEffect } from 'react'
import Flex from '@/elements/Flex'
import Text from '@/elements/Text'
import Button from '@/elements/Button'
import { useRouteError } from 'react-router'
import { MoveLeft, RefreshCcw } from 'lucide-react'
import { recordException } from '@/utils/sentry'
import { useTheme } from '@/utils/theme'

function ErrorFallback() {
  const error: any = useRouteError()
  const { theme } = useTheme()

  useEffect(() => {
    if (typeof error === 'object' && error !== null) {
      recordException(error)
    } else if (typeof error === 'string') {
      recordException(new Error(error))
    } else {
      recordException(new Error('Unknown error'), error)
    }
  }, [error])

  return (
    <Flex
      align='center'
      justify='center'
      gap={4}
      className='auth'
      style={{ height: '100svh' }}
    >
      <Text variant='h2'>
        Oops! Something went wrong.
      </Text>
      <Text variant='footnote'>
        {error ? error?.message || String(error) : 'Unknown error'}
      </Text>
      <Flex gap={2}>
        <Button
          onClick={() => window.location.replace('/')}
          variant={theme === 'dark' ? 'primary' : 'secondary'}
          styles={{
            width: '100%'
          }}
        >
          <MoveLeft />
          Go back to the Dashboard
        </Button>
        <Button onClick={() => window.location.reload()} variant='accent' styles={{ width: '100%' }}>
          <RefreshCcw />
          Try reloading the page
        </Button>
      </Flex>
    </Flex>
  )
}

export default ErrorFallback
